import { connectHook } from 'app/common/components/connect-hook';
import { NavItemLink } from './nav-item-link.js';
import { useNavItemLink } from './nav-item-link-hook.js';

export default connectHook(NavItemLink, useNavItemLink);
